import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { setNodeType } from "@/components/doc/right-sidebar/node-viewer/utils";
import { FormToggle } from "@/components/form/FormToggle";

import type { ConstantNodeModel } from "@/models/nodes/ConstantNodeModel";
import type { VariableNodeModel } from "@/models/nodes/VariableNodeModel";

type Props = {
  node: VariableNodeModel | ConstantNodeModel;
};

export const ConstantToggler = observer(function ConstantToggler({ node }: Props) {
  const t = useTranslations("sidebar.activeNode.title");

  const handleOnToggleChange = () => {
    const nextType = node.type === "constant" ? "variable" : "constant";

    setNodeType([node], nextType);
    node.doc.focus();
  };

  return (
    <label
      htmlFor={`constant-toggler-${node.id}`}
      aria-label={t("constant")}
      className="font-mono text-xxs tracking-tight uppercase flex items-center cursor-pointer px-1.5 py-0.5"
    >
      {t("constant")}
      <FormToggle
        id={`constant-toggler-${node.id}`}
        checked={node.type === "constant"}
        className="ml-auto"
        onClick={(e) => e.stopPropagation()}
        onChange={handleOnToggleChange}
        asInput
      />
    </label>
  );
});
